import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { APPS_FEATURE, RELEASES } from '../../../../../store/utils/files-names';

export const getHasReleasesFormError = (state: AppRootState): boolean =>
  get(state, `${APPS_FEATURE}.${RELEASES}`).hasError;
